import ThemesIntroText from "../../texts/themesScreen/ThemesIntroText";
import ThemesList from "../../lists/themesScreen/themesList";
import {get_themes} from "../../../api/theme";
import {isArrayNullUndefinedOrEmpty, isNullOrUndefined} from "../../../services/Validator";
import {kApiUnknownError, kEmptyResponseError} from "../../../constants/errors";
import {useCallback, useEffect, useState} from "react";
import SystemScreenError from "../../errors/SystemScreenError";
import SystemScreenLoader from "../../loaders/SystemScreenLoader";
import {kFakeThemes} from "../../../services/Faker";
import {sendErrorToSentry} from "../../../services/Sentry";
import {Environment} from "../../../enums/Environment";

export default function ThemesContent() {
    // Used in ThemesScreen to manage Themes related content

    // PROPERTIES
    const [isLoading, setIsLoading] = useState(true)
    const [error, setError] = useState(null)
    const [themes, setThemes] = useState([])

    // HOOKS
    // ---- Define function
    const getThemes = useCallback(() => {
        // <<<< ---- FAKER ---- -----
        if (process.env.REACT_APP_ENV === Environment.FAKER) {
            setThemes(kFakeThemes)
            setIsLoading(false)
            setError(null)
            return
        }
        // ---- ---- FAKER ---- >>>>

        // Set loader on and clear potential error
        setIsLoading(true)
        setError(null)
        // Perform
        get_themes()
            .then((res) => {
                if (isNullOrUndefined(res) || isArrayNullUndefinedOrEmpty(res)) {
                    setError(kEmptyResponseError)
                    sendErrorToSentry(kEmptyResponseError.sentry, 'fetching Themes in ThemesContent')
                } else {
                    setThemes(res)
                }
            }).catch((err) => {
                console.error(err)
                setError(kApiUnknownError)
                sendErrorToSentry(kApiUnknownError.sentry, 'fetching Themes in ThemesContent')
        }).finally(() => {
            setIsLoading(false)
        })
    }, [])
    // ---- Set hook
    useEffect(() => {
        getThemes()
    }, [getThemes])

    // BUILD
    if (!isNullOrUndefined(error))
        return <SystemScreenError error={error}
                                  retryCallback={() => getThemes()} />
    if (isLoading)
        return <SystemScreenLoader />
    return (
        <div className={"animate-appearSlow w-full flex flex-col space-y-24"}>
            <ThemesIntroText />
            <ThemesList themes={themes} />
        </div>
    );
}